import React, { useState } from "react"
import Layout from "../components/layout"
import drRose from "../images/webinar-dr-rose.jpg"
import drPrincenthal from "../images/webinar-dr-princenthal.jpg"

let title = `PSMA Live Event`
let desc = `Join us for a live PSMA PET/CT and Prostate MRI event featuring Dr. Judith Rose and Dr. Robert Princenthal. RSVP now.`

const zoomLink = "https://us02web.zoom.us/webinar/register/WN_rxERQhhgQmGsgn7P_O_EVQ"

const PsmaLive = () => {
    const [submitted, setSubmitted] = useState(false)
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        title: "",
        email: "",
        phone: "",
        practiceCity: "",
        practiceState: "",
    })

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }

    const handleSubmit = (e) => {
        e.preventDefault()

        const dataToSend = {
            name: `${formData.firstName} ${formData.lastName}`,
            title: formData.title,
            email: formData.email,
            phone: formData.phone,
            practiceCity: formData.practiceCity,
            practiceState: formData.practiceState,
            source: "psma-live",
            action: "send-form",
        }

        fetch("https://api.radnetimaging.com/process-form/", {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            method: "POST",
            body: JSON.stringify(dataToSend),
        })
            .then(res => res.json())
            .then(res => {
                setSubmitted(true)
            })
            .catch(err => {
                console.log(err)
                setSubmitted(true)
            })
    }

    return (
        <Layout page={title} desc={desc}>
            <div className="psma-live-page">
                <div className="psma-hero">
                    <div className="psma-hero-gradient">
                        <div className="psma-hero-content">
                            <p className="psma-invite">Please join us for an educational dinner</p>
                            <h1 className="psma-event-title">PSMA PET/CT &amp; Prostate MRI:<br />Current and Future</h1>
                            <h2 className="psma-day">Thursday</h2>
                            <br />
                            <div className="psma-date-row">
                                <span className="psma-month">March</span>
                                <span className="psma-date-number">19</span>
                            </div>
                            <br /><br />
                            <div className="psma-venue-row">
                                <div className="psma-venue-col">
                                    <p>Arroyo Chop House</p>
                                    <p>536 S. Arroyo Parkway</p>
                                    <p>Pasadena, CA 91105</p>
                                    <p><strong>5:30PM PST</strong></p>
                                    <a href="#rsvp-form" className="psma-zoom-btn" onClick={(e) => { e.preventDefault(); document.getElementById('rsvp-form').scrollIntoView({ behavior: 'smooth' }) }}>RSVP for Dinner</a>
                                </div>
                                <div className="psma-venue-col">
                                    <p>Can't make it?</p>
                                    <p>Join us virtually.</p>
                                    <p>Thursday, March 19, 2026</p>
                                    <p><strong>6:15PM PST</strong></p>
                                    <a href={zoomLink} target="_blank" rel="noopener noreferrer" className="psma-zoom-btn">Register for Virtual Event</a>
                                </div>
                            </div>
                            <hr className="psma-divider" />
                            <p className="psma-contact">
                                For questions, contact Monique Jenkins<br />
                                <a href="mailto:Monique.Jenkins@RadNet.com">Monique.Jenkins@RadNet.com</a> &nbsp;|&nbsp; <a href="tel:+18182807707">(818) 280-7707</a>
                            </p>
                            <p className="psma-contact">
                                or Brianna Davis<br />
                                <a href="mailto:Brianna.Davis@RadNet.com">Brianna.Davis@RadNet.com</a> &nbsp;|&nbsp; <a href="tel:+16263484095">(626) 348-4095</a>
                            </p>
                        </div>
                    </div>

                    <div className="psma-speakers-section">
                        <h3 className="psma-speakers-title">Speakers:</h3>
                        <hr className="psma-speakers-divider" />

                        <div className="psma-speaker">
                            <div className="psma-speaker-photo">
                                <img src={drRose} alt="Dr. Judith Rose" />
                            </div>
                            <div className="psma-speaker-info">
                                <h4>Judith Rose, MD</h4>
                                <p className="psma-speaker-role">Director of PET/CT &amp; Medical Research</p>
                                <ul>
                                    <li>PSMA PET/CT: From Validation to Clinical Impact: Where Are We? And What's Next?</li>
                                </ul>
                            </div>
                        </div>

                        <div className="psma-speaker">
                            <div className="psma-speaker-photo">
                                <img src={drPrincenthal} alt="Dr. Robert Princenthal" />
                            </div>
                            <div className="psma-speaker-info">
                                <h4>Robert Princenthal, MD</h4>
                                <p className="psma-speaker-role">Medical Director Prostate Imaging</p>
                                <ul>
                                    <li>How We Can Improve Prostate Cancer Detection: The Role of PSA, MRI, and Precision Diagnostics</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="rsvp-form" className="psma-rsvp-section">
                    <div className="psma-rsvp-columns">
                        <div className="psma-rsvp-col-form">
                            {!submitted ? (
                                <div className="psma-rsvp-form-wrapper">
                                    <h2>RSVP: In-Person Dinner</h2>
                                    <p className="psma-rsvp-subtitle">Reserve your seat at Arroyo Chop House on March 19.</p>
                                    <form onSubmit={handleSubmit} className="psma-rsvp-form">
                                        <div className="psma-form-row">
                                            <fieldset>
                                                <label htmlFor="firstName">First Name</label>
                                                <input
                                                    type="text"
                                                    id="firstName"
                                                    name="firstName"
                                                    value={formData.firstName}
                                                    onChange={handleChange}
                                                    required
                                                    placeholder="First Name"
                                                />
                                            </fieldset>
                                            <fieldset>
                                                <label htmlFor="lastName">Last Name</label>
                                                <input
                                                    type="text"
                                                    id="lastName"
                                                    name="lastName"
                                                    value={formData.lastName}
                                                    onChange={handleChange}
                                                    required
                                                    placeholder="Last Name"
                                                />
                                            </fieldset>
                                        </div>
                                        <div className="psma-form-row">
                                            <fieldset>
                                                <label htmlFor="title">Title</label>
                                                <input
                                                    type="text"
                                                    id="title"
                                                    name="title"
                                                    value={formData.title}
                                                    onChange={handleChange}
                                                    required
                                                    placeholder="MD, DO, NP, PA, etc."
                                                />
                                            </fieldset>
                                            <fieldset>
                                                <label htmlFor="practiceCity">City of Practice</label>
                                                <input
                                                    type="text"
                                                    id="practiceCity"
                                                    name="practiceCity"
                                                    value={formData.practiceCity}
                                                    onChange={handleChange}
                                                    required
                                                    placeholder="City"
                                                />
                                            </fieldset>
                                        </div>
                                        <div className="psma-form-row">
                                            <fieldset>
                                                <label htmlFor="practiceState">State of Practice</label>
                                                <input
                                                    type="text"
                                                    id="practiceState"
                                                    name="practiceState"
                                                    value={formData.practiceState}
                                                    onChange={handleChange}
                                                    required
                                                    placeholder="State"
                                                />
                                            </fieldset>
                                        </div>
                                        <div className="psma-form-row">
                                            <fieldset>
                                                <label htmlFor="email">Email</label>
                                                <input
                                                    type="email"
                                                    id="email"
                                                    name="email"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    required
                                                    placeholder="example@address.com"
                                                />
                                            </fieldset>
                                            <fieldset>
                                                <label htmlFor="phone">Phone</label>
                                                <input
                                                    type="tel"
                                                    id="phone"
                                                    name="phone"
                                                    value={formData.phone}
                                                    onChange={handleChange}
                                                    required
                                                    placeholder="(000) 000-0000"
                                                />
                                            </fieldset>
                                        </div>
                                        <div className="psma-form-submit">
                                            <button type="submit" className="submit-form">RSVP for In-Person Dinner</button>
                                        </div>
                                    </form>
                                </div>
                            ) : (
                                <div className="psma-rsvp-thanks">
                                    <h2>Thank You for Your RSVP!</h2>
                                    <p>You're all set. We look forward to seeing you at the dinner on Thursday, March 19 at 5:30 PM PST.</p>
                                </div>
                            )}
                        </div>
                        <div className="psma-rsvp-col-virtual">
                            <div className="psma-rsvp-virtual-wrapper">
                                <h2>RSVP: Virtual Event</h2>
                                <p>Register through Zoom to attend the virtual broadcast on March 19 at 6:15 PM PST.</p>
                                <a href={zoomLink} target="_blank" rel="noopener noreferrer" className="psma-zoom-btn-lg">Register on Zoom</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default PsmaLive
